import React from 'react';
import { CrossSellPromo } from '@stitch-fix/mode-react';
import { useViewEvent } from '@stitch-fix/event-reporter';
import { useGetFixPromotionQuery } from './getFixPromotion';

/**
 * The `FixPromotion` component requests and renders the content
 * for the CrossSellPromo component.
 */
const FixPromotion = () => {
  const { data } = useGetFixPromotionQuery();
  const fixPromotion = data?.shopContent?.fixPromotion;

  const { ref, EventProvider, reportSelectEvent } = useViewEvent({
    content_id: 'order_a_fix',
    name: 'call_to_action_module',
    schema: 'view',
  });

  if (!fixPromotion) return null;

  return (
    <EventProvider>
      <div ref={ref}>
        <CrossSellPromo
          variant="fix"
          image={fixPromotion.image}
          expandedContent={fixPromotion.expandedContent}
          cta={fixPromotion.cta}
          onClick={() => {
            reportSelectEvent({
              action_name: 'navigate_to_call_to_action_destination',
              content_id: 'order_a_fix',
              name: 'call_to_action_module',
              schema: 'select',
            });
          }}
        />
      </div>
    </EventProvider>
  );
};

export default FixPromotion;
